module.exports = __webpack_public_path__ + "img/market-store-offline.63a6c6a8.png";